<div class="d-flex justify-content-center">

    @if (isLoading()) {
            <div class="spinner-border spinner-border-sm"> <span class="visually-hidden">Loading...</span></div>
    } @else {
         <span
            (click)="downloadDoc()"
            stop-click-bubble
            role="button"
            class="font-5">
            <svg-icon key="folder-search" fontSize="1.5rem"></svg-icon>
        </span>
    }
   

    <!-- <span
        stop-click-bubble
        role="button"
        class="font-5">
        <svg-icon key="folder-search" fontSize="1.5rem"></svg-icon>
    </span> -->

    <!-- <span
        stop-click-bubble
        role="button"
        class="font-5">
        <svg-icon key="remove" fontSize="1.5rem"></svg-icon>
    </span> -->
</div>
